import { loadGoogleMapsScript } from './googleMapsLoader';

/**
 * Driving distance in meters between two points (same basis as map modal Directions).
 * Returns null if Directions fails or is unavailable.
 */
export async function fetchDrivingDistanceMeters(
    apiKey: string,
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number }
): Promise<number | null> {
    await loadGoogleMapsScript(apiKey);
    const ds = new google.maps.DirectionsService();
    return new Promise((resolve) => {
        ds.route(
            {
                origin: { lat: origin.lat, lng: origin.lng },
                destination: { lat: destination.lat, lng: destination.lng },
                travelMode: google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status !== google.maps.DirectionsStatus.OK || !result?.routes?.[0]?.legs?.[0]) {
                    resolve(null);
                    return;
                }
                const v = result.routes[0].legs[0].distance?.value;
                resolve(typeof v === 'number' && Number.isFinite(v) ? v : null);
            }
        );
    });
}

/** Label for branch "distance from region" field (driving km, one decimal). */
export function formatDrivingKmLabel(distanceMeters: number): string {
    return `${(distanceMeters / 1000).toFixed(1)} km`;
}
